(() => {
  const GLOBAL_COLOR_CATALOG = (() => {
    const node = document.querySelector('[data-global-color-catalog]');
    if(!node) return [];
    try{ return JSON.parse(node.textContent || '[]').filter(Boolean); }catch(_){ return []; }
  })();
  const cards = [...document.querySelectorAll('.color-card')];
  const selectedWrap = document.querySelector('[data-selected-colors]');
  const kitTitle = document.querySelector('[data-kit-title]');
  const kitSubtitle = document.querySelector('[data-kit-subtitle]');
  const addBtn = document.querySelector('[data-add-kit]');
  const kitPrice = document.querySelector('[data-kit-price]');
  const compareBtn = document.querySelector('[data-compare]');
  const section = document.querySelector('.color-builder-section');
  const modal = document.querySelector('[data-color-modal]');
  const compareModal = document.querySelector('[data-compare-modal]');
  const search = document.querySelector('[data-color-search]');
  const globalSearch = document.querySelector('[data-global-color-search]');
  const filterSelects = [...document.querySelectorAll('[data-filter-select]')];
  const sortSelect = document.querySelector('[data-sort-select]');
  const groupSelect = document.querySelector('[data-group-select]');
  const clearFiltersBtn = document.querySelector('[data-clear-filters]');
  if (groupSelect && (!groupSelect.value || groupSelect.value === 'none')) { groupSelect.value = 'brand'; }
  const searchResults = document.querySelector('[data-search-results]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerBackdrop = document.querySelector('[data-cart-drawer-backdrop]');
  const cartDrawerItems = document.querySelector('[data-cart-drawer-items]');
  const openCartBtn = document.querySelector('[data-open-cart]');
  const closeCartBtn = document.querySelector('[data-close-cart]');
  let selected = [];
  let activeCard = null;
  function updateKitReminderCards(){
    document.querySelectorAll('[data-kit-reminder]').forEach(card => {
      card.classList.toggle('is-active', String(selected.length) === String(card.dataset.kitReminder));
    });
  }
  let activeFilters = { brand:'all', group:'all', finish:'all', availability:'all' };
  const params = new URLSearchParams(window.location.search);
  const initialQ = params.get('q') || params.get('search') || '';
  const initialBrand = params.get('brand');
  const initialFocus = params.get('focus') || params.get('from');
  if(initialBrand){ activeFilters.brand = initialBrand; }
  if(initialQ){ if(search) search.value = initialQ; if(globalSearch) globalSearch.value = initialQ; }
  filterSelects.forEach(select => {
    const val = activeFilters[select.dataset.filterSelect];
    if(val && [...select.options].some(o => o.value === val)) select.value = val;
  });
  const kitMap = {1:{name:'The Confirm', price:'$100', attr:'kitOne'},2:{name:'The Decide', price:'$200', attr:'kitTwo'},3:{name:'The Compose', price:'$250', attr:'kitThree'}};
  const revealItems = [...document.querySelectorAll('.reveal')];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if(entry.isIntersecting){ entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    revealItems.forEach(item => observer.observe(item));
  } else { revealItems.forEach(item => item.classList.add('is-visible')); }
  document.querySelectorAll('[data-smooth-scroll], a[href^="#"]').forEach(link => link.addEventListener('click', e => {
    const href = link.getAttribute('href');
    if(!href || href === '#') return;
    const target = document.querySelector(href);
    if(target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'start'}); }
  }));

  const cleanBrand = (value) => String(value || '').replace(/^\s*\[\s*/, '').replace(/\s*\]\s*$/, '').replace(/^['\"]|['\"]$/g, '').trim();
  const getData = (card) => ({name:card.dataset.name, code:card.dataset.code, brand:cleanBrand(card.dataset.brand), group:card.dataset.group, finish:card.dataset.finish, availability:card.dataset.availability, description:card.dataset.description, hex:card.dataset.hex, image:card.dataset.image || ''});
  function passes(card){
    const q = (search?.value || globalSearch?.value || '').trim().toLowerCase();
    const matchesSearch = !q || `${card.dataset.name} ${card.dataset.code} ${card.dataset.brand} ${card.dataset.group} ${card.dataset.finish} ${card.dataset.availability}`.toLowerCase().includes(q);
    const matchesFilters = Object.entries(activeFilters).every(([type,value]) => value === 'all' || card.dataset[type] === value);
    return matchesSearch && matchesFilters;
  }
  function applyVisibility(){ cards.forEach(card => { card.style.display = passes(card) ? '' : 'none'; }); }
  function updateBuilderProgress(){
    const progress = document.querySelector('[data-builder-progress]');
    if(progress) progress.style.width = `${Math.min(100, (selected.length / 3) * 100)}%`;
  }
  function animateToBuilder(card){ return; }
  function render(){
    cards.forEach(c => {
      const isSelected = selected.some(s => s.name === c.dataset.name && s.code === c.dataset.code);
      c.classList.toggle('selected', isSelected);
      const btn = c.querySelector('.select-color');
      if(btn) btn.textContent = isSelected ? 'Remove from Kit' : 'Add to Kit';
      const check = c.querySelector('[data-select-check]');
      if(check) check.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    if(selectedWrap) selectedWrap.innerHTML = selected.length ? selected.map((s,i)=>{
      const dotStyle = s.image ? `--dot:${s.hex};background-image:url('${String(s.image).replace(/'/g, "%27")}')` : `--dot:${s.hex}`;
      return `<div class="selected-pill" title="Remove ${s.name}"><span class="selected-dot${s.image ? ' has-image' : ''}" style="${dotStyle}"></span><span>${s.name}</span><button type="button" aria-label="Remove ${s.name}" data-remove="${i}">×</button></div>`;
    }).join('') : '<span class="empty-kit-note">No colors selected yet.</span>';
    updateBuilderProgress();
    updateKitReminderCards();
    if(!kitTitle) return;
    const count = selected.length;
    if(count === 0){
      kitTitle.textContent='Select up to 3 colors';
      if(kitPrice) kitPrice.textContent='$0';
      kitSubtitle.textContent='0 selected';
      if(addBtn){ addBtn.disabled=true; addBtn.textContent='Add to Cart'; }
      if(compareBtn){ compareBtn.disabled=true; compareBtn.textContent='Compare'; }
      return;
    }
    const kit = kitMap[count];
    kitTitle.textContent = `${kit.name} · ${count} Sample${count>1?'s':''}`;
    if(kitPrice) kitPrice.textContent = kit.price;
    kitSubtitle.textContent = `${count} selected`;
    if(addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
    if(compareBtn){ compareBtn.disabled = count < 2; compareBtn.textContent = 'Compare'; }
  }
  function add(card){
    const data = getData(card);
    const exists = selected.some(s => s.name === data.name && s.code === data.code);
    if(exists){
      selected = selected.filter(s => !(s.name === data.name && s.code === data.code));
    }
    else if(selected.length < 3){
      selected.push(data);
      animateToBuilder(card);
    }
    else {
      showToast('This kit is full. Add it to cart, then build another.');
    }
    render();
  }

  function openColorModal(card){
    if(!card || !modal) return;
    activeCard = card;
    const d=getData(card);
    const modalSwatch = modal.querySelector('[data-modal-swatch]');
    if(modalSwatch){
      modalSwatch.style.setProperty('--modal-swatch', d.hex);
      if(d.image){ modalSwatch.style.backgroundImage = `url(${d.image})`; modalSwatch.classList.add('has-image'); }
      else { modalSwatch.style.backgroundImage = ''; modalSwatch.classList.remove('has-image'); }
    }
    modal.querySelector('[data-modal-name]').textContent=d.name;
    modal.querySelector('[data-modal-meta]').textContent=`${cleanBrand(d.brand)} · ${d.code} · ${d.finish} · ${d.availability}`;
    modal.querySelector('[data-modal-description]').textContent=d.description;
    const modalAdd = modal.querySelector('[data-modal-add]');
    if(modalAdd){ const exists = selected.some(s => s.name === d.name && s.code === d.code); modalAdd.textContent = exists ? 'Remove from Kit' : 'Add to Kit'; }
    modal.hidden=false;
  }
  function sortAndGroup(){
    const grid = document.querySelector('.color-grid'); if(!grid) return;
    [...grid.querySelectorAll('.group-heading')].forEach(h=>h.remove());
    const cardsSorted = [...cards].sort((a,b)=>{
      const mode = sortSelect?.value || 'az';
      if(mode === 'za') return b.dataset.name.localeCompare(a.dataset.name);
      if(mode === 'brand') return (a.dataset.brand+a.dataset.name).localeCompare(b.dataset.brand+b.dataset.name);
      if(mode === 'family') return (a.dataset.group+a.dataset.name).localeCompare(b.dataset.group+b.dataset.name);
      return a.dataset.name.localeCompare(b.dataset.name);
    });
    const groupMode = groupSelect?.value || 'brand';
    if(groupMode && groupMode !== 'none'){
      const buckets = new Map();
      cardsSorted.forEach(card => {
        const label = groupMode === 'brand' ? card.dataset.brand : groupMode === 'availability' ? card.dataset.availability : groupMode === 'finish' ? card.dataset.finish : groupMode === 'family' || groupMode === 'group' ? card.dataset.group : '';
        const display = (label || 'Other').trim() || 'Other';
        const bucketKey = display.toLowerCase();
        if(!buckets.has(bucketKey)) buckets.set(bucketKey, { label: display, cards: [] });
        buckets.get(bucketKey).cards.push(card);
      });
      [...buckets.values()].sort((a,b)=>a.label.localeCompare(b.label, undefined, {sensitivity:'base'})).forEach(bucket => {
        const heading = document.createElement('div'); heading.className='group-heading'; heading.dataset.groupHeading='true';
        heading.innerHTML = `<h3>${bucket.label}</h3><span>${bucket.cards.length} color${bucket.cards.length === 1 ? '' : 's'}</span>`;
        grid.appendChild(heading);
        bucket.cards.forEach(card => grid.appendChild(card));
      });
    } else {
      cardsSorted.forEach(card => grid.appendChild(card));
    }
  }
  function filtersAreActive(){
    const q = (search?.value || globalSearch?.value || '').trim();
    return q || Object.values(activeFilters).some(v=>v !== 'all') || (sortSelect && sortSelect.value !== 'az') || (groupSelect && groupSelect.value !== 'none');
  }
  function updateClearFilters(){ clearFiltersBtn?.classList.toggle('is-visible', !!filtersAreActive()); }
  function renderSearchResults(){
    if(!searchResults || !globalSearch) return;
    const q = globalSearch.value.trim().toLowerCase();
    if(!q){ searchResults.classList.remove('is-open'); searchResults.innerHTML=''; return; }
    const source = cards.length ? cards.map(c => ({name:c.dataset.name, code:c.dataset.code, brand:cleanBrand(c.dataset.brand), group:c.dataset.group, handle:c.dataset.handle || '', image:c.dataset.image || '', url:`/collections/colors?color=${encodeURIComponent(c.dataset.handle || c.dataset.name || '')}`})) : GLOBAL_COLOR_CATALOG.map(c => ({...c, brand:cleanBrand(c.brand)}));
    const matches = source.filter(c => `${c.name} ${c.code} ${c.brand} ${c.group}`.toLowerCase().includes(q)).slice(0,8);
    searchResults.innerHTML = matches.length ? matches.map(c => { const img = c.image ? `<span class="search-result-thumb" style="background-image:url('${String(c.image).replace(/'/g,'%27')}')"></span>` : `<span class="search-result-thumb is-empty"></span>`; return `<button class="search-result" type="button" data-result-name="${String(c.name).replace(/"/g,'&quot;')}" data-result-code="${String(c.code).replace(/"/g,'&quot;')}" data-result-handle="${String(c.handle || '').replace(/"/g,'&quot;')}" data-result-url="${String(c.url || ('/collections/colors?color=' + encodeURIComponent(c.handle || c.name || ''))).replace(/"/g,'&quot;')}">${img}<span class="search-result-copy"><strong>${c.name}</strong><span>${[cleanBrand(c.brand), c.code].filter(Boolean).join(' · ')}</span></span></button>`; }).join('') : '<div class="search-result"><strong>No colors found</strong><span>Try a name or code</span></div>';
    searchResults.classList.add('is-open');
  }
  function openCartDrawer(){ cartDrawer?.classList.add('is-open'); cartDrawerBackdrop?.classList.add('is-open'); cartDrawer?.setAttribute('aria-hidden','false'); renderCartDrawer(); }
  function closeCartDrawer(){ cartDrawer?.classList.remove('is-open'); cartDrawerBackdrop?.classList.remove('is-open'); cartDrawer?.setAttribute('aria-hidden','true'); }
  function formatCartMoney(cents){
    const amount = Number(cents || 0) / 100;
    return amount.toLocaleString(undefined, {style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', minimumFractionDigits: amount % 1 ? 2 : 0});
  }
  function parseColorProperty(value){
    const text = String(value || '').trim();
    const match = text.match(/^(.*?)\s*\((.*?)\s*[·•-]\s*(.*?)\)\s*$/);
    if(match) return {name:match[1].trim(), brand:cleanBrand(match[2]), code:match[3].trim()};
    return {name:text, brand:'', code:''};
  }
  function getCartKitName(item){
    const props = item.properties || {};
    return props['Kit Type'] || props['kit_type'] || item.product_title || item.title || 'Spec Kit';
  }
  function normalizeImageUrl(value){
    const raw = String(value || '').trim();
    if(!raw || raw === 'undefined' || raw === 'null') return '';
    if(raw.startsWith('//')) return `${window.location.protocol}${raw}`;
    return raw;
  }
  function findColorCatalogMatch(color){
    const name = String(color?.name || '').trim().toLowerCase();
    const code = String(color?.code || '').trim().toLowerCase();
    const handle = String(color?.handle || '').trim().toLowerCase();
    return GLOBAL_COLOR_CATALOG.find(item => {
      const itemName = String(item.name || '').trim().toLowerCase();
      const itemCode = String(item.code || '').trim().toLowerCase();
      const itemHandle = String(item.handle || '').trim().toLowerCase();
      return (handle && itemHandle === handle) || (name && code && itemName === name && itemCode === code) || (name && itemName === name);
    }) || null;
  }
  function getCartColors(item){
    const props = item.properties || {};
    return [1,2,3].map(i => {
      const raw = props[`Color ${i}`] || props[`Sample ${i}`] || '';
      if(!raw) return null;
      const parsed = parseColorProperty(raw);
      parsed.handle = props[`Color ${i} Handle`] || props[`_Color ${i} Handle`] || '';
      const catalogMatch = findColorCatalogMatch(parsed);
      parsed.image = normalizeImageUrl(props[`Color ${i} Image`] || props[`_Color ${i} Image`] || catalogMatch?.image || '');
      parsed.hex = props[`Color ${i} Hex`] || props[`_Color ${i} Hex`] || catalogMatch?.hex || '';
      return parsed;
    }).filter(Boolean);
  }
  async function removeCartLine(key){
    if(!key) return;
    try{
      await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity:0})});
      await renderCartDrawer();
    }catch(_){ showToast('Unable to remove this kit.'); }
  }
  async function renderCartDrawer(){
    if(!cartDrawerItems) return;
    try{
      const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent = cart.item_count);
      const subtotal = document.querySelector('[data-cart-drawer-subtotal]');
      if(subtotal) subtotal.textContent = formatCartMoney(cart.total_price);
      if(!cart.items.length){
        cartDrawerItems.innerHTML='<p class="cart-drawer-empty">Your cart is empty.</p>';
        return;
      }
      const escapeCartHtml = value => String(value || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
      const visibleProperties = props => Object.entries(props || {}).filter(([name, value]) => {
        const key = String(name || '');
        const lower = key.toLowerCase();
        return value !== null && value !== undefined && String(value).trim() !== '' && key.charAt(0) !== '_' && !lower.includes('image') && !lower.includes('handle') && !lower.includes('hex');
      });
      cartDrawerItems.innerHTML = cart.items.map(item=>{
        const colors = getCartColors(item);
        const kitName = getCartKitName(item);
        const price = formatCartMoney(item.final_line_price || item.line_price || item.price);
        const title = escapeCartHtml(item.product_title || item.title || kitName);
        const quantity = Number(item.quantity || 1);
        const itemImage = normalizeImageUrl(item.image || item.featured_image?.url || '');
        const productThumb = itemImage
          ? `<span class="cart-color-thumb has-image"><img src="${itemImage.replace(/'/g,'%27')}" alt="" loading="lazy"></span>`
          : '<span class="cart-color-thumb"></span>';
        let detailLabel = escapeCartHtml(kitName);
        let detailList = '';
        if (colors.length) {
          detailList = colors.map(color => {
            const safeImage = normalizeImageUrl(color.image).replace(/'/g,'%27');
            const fallbackStyle = color.hex ? ` style="background-color:${String(color.hex).replace(/"/g,'&quot;')}"` : '';
            const thumb = safeImage
              ? `<span class="cart-color-thumb has-image"${fallbackStyle}><img src="${safeImage}" alt="" loading="lazy"></span>`
              : `<span class="cart-color-thumb"${fallbackStyle}></span>`;
            const meta = [color.brand, color.code].filter(Boolean).join(' · ');
            return `<li>${thumb}<span><strong>${escapeCartHtml(color.name)}</strong>${meta ? `<small>${escapeCartHtml(meta)}</small>` : ''}</span></li>`;
          }).join('');
        } else {
          detailLabel = 'Product Details';
          const propRows = visibleProperties(item.properties).map(([name, value]) => {
            return `<li class="drawer-kit-detail"><span><strong>${escapeCartHtml(name)}</strong><small>${escapeCartHtml(value)}</small></span></li>`;
          }).join('');
          detailList = `<li>${productThumb}<span><strong>${title}</strong><small>Quantity: ${quantity}</small></span></li>${propRows}`;
        }
        return `<article class="drawer-kit-card"><button class="drawer-kit-remove" type="button" data-cart-remove-key="${String(item.key || '').replace(/"/g,'&quot;')}" aria-label="Remove ${title}">×</button><h3>${title}</h3><p class="drawer-kit-price">${price}</p><div class="drawer-kit-compose"><span>${detailLabel}</span><ul>${detailList}</ul></div></article>`;
      }).join('');
    }catch(_){ cartDrawerItems.innerHTML='<p>Cart could not be loaded.</p>'; }
  }

  cards.forEach(card => {
    card.addEventListener('pointermove', e => { const sw = card.querySelector('.swatch'); if(!sw) return; const r = sw.getBoundingClientRect(); sw.style.setProperty('--mx', ((e.clientX-r.left)/r.width*100).toFixed(1)+'%'); sw.style.setProperty('--my', ((e.clientY-r.top)/r.height*100).toFixed(1)+'%'); });
    card.querySelector('.select-color')?.addEventListener('click', e => { e.stopPropagation(); add(card); });
    card.querySelector('[data-select-check]')?.addEventListener('click', e => { e.stopPropagation(); add(card); });
    card.querySelector('.swatch')?.addEventListener('click', () => openColorModal(card));
  });
  document.addEventListener('click', e => { if(e.target.dataset.remove){ selected.splice(Number(e.target.dataset.remove),1); render(); } });
  document.querySelector('[data-close-modal]')?.addEventListener('click',()=> modal.hidden=true);
  document.querySelector('[data-modal-add]')?.addEventListener('click',()=>{ if(activeCard) add(activeCard); modal.hidden=true; });
  document.querySelector('[data-close-compare]')?.addEventListener('click',()=> compareModal.hidden=true);
  compareBtn?.addEventListener('click',()=>{ const grid=compareModal.querySelector('[data-compare-grid]'); grid.innerHTML=selected.map(s=>{ const imageStyle = s.image ? `--compare-image:url('${String(s.image).replace(/'/g, '%27')}');` : ''; const imageClass = s.image ? ' has-image' : ''; const brand = cleanBrand(s.brand); return `<article class="compare-card"><div class="compare-swatch${imageClass}" style="--swatch:${s.hex};${imageStyle}"></div><h3>${s.name}</h3><p>${brand ? `${brand} · ` : ''}${s.code}</p><p>${s.finish} · ${s.availability}</p></article>`; }).join(''); compareModal.hidden=false; });
  // Color filtering is owned exclusively by the v3.0.61 isolated filter module below.
  globalSearch?.addEventListener('input', () => { renderSearchResults(); updateGlobalSearchClear(); });
  const globalSearchClear = document.querySelector('[data-global-search-clear]');
  function updateGlobalSearchClear(){ if(globalSearchClear && globalSearch) globalSearchClear.hidden = !globalSearch.value.trim(); }
  globalSearchClear?.addEventListener('click', () => { if(!globalSearch) return; globalSearch.value=''; renderSearchResults(); updateGlobalSearchClear(); globalSearch.focus(); });
  updateGlobalSearchClear();
  searchResults?.addEventListener('click', e => {
    const btn = e.target.closest('[data-result-name]'); if(!btn) return;
    const card = cards.find(c => c.dataset.name === btn.dataset.resultName && c.dataset.code === btn.dataset.resultCode);
    if(card){ if(search) search.value=''; if(globalSearch) globalSearch.value=''; renderSearchResults(); openColorModal(card); }
    else { const handle = btn.dataset.resultHandle || ''; window.location.href = btn.dataset.resultUrl || `/collections/colors?color=${encodeURIComponent(handle || btn.dataset.resultName || '')}`; }
  });
  document.addEventListener('click', e => { if(!e.target.closest('.header-search')) searchResults?.classList.remove('is-open'); });
  openCartBtn?.addEventListener('click', openCartDrawer);
  closeCartBtn?.addEventListener('click', closeCartDrawer);
  cartDrawerBackdrop?.addEventListener('click', closeCartDrawer);
  cartDrawerItems?.addEventListener('click', e => { const btn = e.target.closest('[data-cart-remove-key]'); if(btn) removeCartLine(btn.dataset.cartRemoveKey); });
  function showToast(message){
    let toast = document.querySelector('[data-cart-toast]');
    if(!toast){
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.dataset.cartToast = 'true';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(()=>toast.classList.remove('is-visible'), 3200);
  }
  async function refreshCartCount(){
    try{
      const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent = cart.item_count);
    } catch(_){}
  }
  async function resolveKitVariantId(count){
    const key = count===1?'kitOne':count===2?'kitTwo':'kitThree';
    const handleKey = count===1?'kitOneHandle':count===2?'kitTwoHandle':'kitThreeHandle';
    const directId = String(section?.dataset[key] || '').trim();
    if(directId) return directId;

    const primaryHandle = String(section?.dataset[handleKey] || '').trim();
    const fallbackHandles = count === 1
      ? ['1-sample-kit','one-sample-kit','the-confirm','sample-kit-1']
      : count === 2
        ? ['2-sample-kit','two-sample-kit','the-decide','sample-kit-2']
        : ['3-sample-kit','three-sample-kit','the-compose','sample-kit-3'];
    const handles = [...new Set([primaryHandle, ...fallbackHandles].filter(Boolean))];

    for(const handle of handles){
      try{
        const product = await fetch(`/products/${encodeURIComponent(handle)}.js`, {headers:{'Accept':'application/json'}}).then(r => r.ok ? r.json() : null);
        const variant = product?.variants?.find(v => v.available) || product?.variants?.[0];
        if(variant?.id){
          if(section) section.dataset[key] = String(variant.id);
          return String(variant.id);
        }
      } catch(_){}
    }
    return '';
  }

  addBtn?.addEventListener('click', async (event)=>{
    event.preventDefault();
    event.stopPropagation();
    const count = selected.length; if(!count) return;
    const variantId = await resolveKitVariantId(count);
    if(!variantId){ alert(`The ${count} sample kit product could not be found. Select the kit products in the Color builder section settings, or set the fallback product handles to match Shopify.`); return; }
    const kitSnapshot = [...selected];
    const properties = kitSnapshot.reduce((acc,s,i)=>{
      const n = i + 1;
      acc[`Color ${n}`]=`${s.name}${s.code ? ` (${cleanBrand(s.brand)} · ${s.code})` : ` (${cleanBrand(s.brand)})`}`;
      // Keep technical cart-drawer data private so Shopify checkout does not
      // display raw image URLs, handles, or hex values in the order summary.
      // Public properties remain limited to the selected color label, kit type,
      // and sample count.
      acc[`_Color ${n} Image`] = normalizeImageUrl(s.image || '');
      acc[`_Color ${n} Handle`] = s.handle || '';
      acc[`_Color ${n} Hex`] = s.hex || '';
      return acc;
    },{});
    properties['Kit Type'] = kitMap[count].name;
    properties['Sample Count'] = String(count);
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    try{
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      Object.entries(properties).forEach(([name,value]) => formData.append(`properties[${name}]`, value));
      const res = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:formData});
      if(!res.ok){
        let message = 'Cart add failed';
        try{ const err = await res.json(); message = err.description || err.message || message; } catch(_){}
        throw new Error(message);
      }
      selected = [];
      render();
      await refreshCartCount();
      showToast(`${kitMap[count].name} added to cart. Build another kit or view cart when ready.`);
      openCartDrawer();
    }
    catch(err){ alert(err?.message || 'Unable to add this kit to cart. Check that kit products are configured and available.'); }
    finally{ render(); }
  });

  // Subtle scroll-responsive motion: faster scroll slightly tightens reveal timing.
  let lastScrollY = window.scrollY;
  let lastScrollT = performance.now();
  let scrollTimer;


  // Stable cart opener: delegated so the cart drawer opens from every page/template.
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if(opener){
      e.preventDefault();
      openCartDrawer();
    }
  });

  window.addEventListener('scroll', () => {
    const now = performance.now();
    const dy = Math.abs(window.scrollY - lastScrollY);
    const dt = Math.max(now - lastScrollT, 16);
    const velocity = Math.min(1.55, Math.max(1, dy / dt / 1.2));
    document.documentElement.style.setProperty('--scroll-motion', velocity.toFixed(2));
    document.body.classList.toggle('is-fast-scrolling', velocity > 1.18);
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
  const GLOBAL_COLOR_CATALOG = (() => {
    const node = document.querySelector('[data-global-color-catalog]');
    if(!node) return [];
    try{ return JSON.parse(node.textContent || '[]').filter(Boolean); }catch(_){ return []; }
  })();
      document.body.classList.remove('is-fast-scrolling');
      document.documentElement.style.setProperty('--scroll-motion', '1');
    }, 160);
    lastScrollY = window.scrollY;
    lastScrollT = now;
  }, { passive:true });

  function showPrefilterToast(message){
    let toast = document.querySelector('[data-prefilter-toast]');
    if(!toast){
      toast = document.createElement('div');
      toast.className = 'prefilter-toast';
      toast.dataset.prefilterToast = 'true';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showPrefilterToast.timer);
    showPrefilterToast.timer = setTimeout(()=>toast.classList.remove('is-visible'), 2600);
  }
  function runPrefilterArrival(){
    if(!section || (!initialBrand && initialFocus !== 'builder')) return;
    section.classList.add('is-arriving');
    setTimeout(()=>section.classList.remove('is-arriving'), 1300);
    if(initialBrand) showPrefilterToast(`${initialBrand} colors loaded`);
    if(initialFocus === 'builder') setTimeout(()=>section.scrollIntoView({behavior:'smooth', block:'start'}), 90);
  }
  render();
  runPrefilterArrival();
  const initialColor = params.get('color');
  if(initialColor){ const target = initialColor.toLowerCase(); const card = cards.find(c => (c.dataset.handle || '').toLowerCase() === target || (c.dataset.name || '').toLowerCase() === target || (c.dataset.code || '').toLowerCase() === target); if(card) setTimeout(()=>{ card.scrollIntoView({behavior:'smooth', block:'center'}); openColorModal(card); }, 220); }
})();


// Safe hero scroll polish: subtle headline fade + background parallax/blur.
(function(){
  const hero = document.querySelector('.hero');
  const heroInner = hero ? hero.querySelector('.hero-inner') : null;
  if(!hero || !heroInner || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let ticking = false;
  function updateHeroScroll(){
    const rect = hero.getBoundingClientRect();
    const height = Math.max(hero.offsetHeight || 1, 1);
    const progress = Math.min(1, Math.max(0, -rect.top / height));
    heroInner.style.opacity = String(Math.max(0, 1 - progress * 1.65));
    heroInner.style.transform = `translateY(${progress * 34}px)`;
    hero.style.setProperty('--hero-parallax-y', `${progress * 34}px`);
    hero.style.setProperty('--hero-blur', `${progress * 4}px`);
    ticking = false;
  }
  const style = document.createElement('style');
  style.textContent = `.hero:before{transform:scale(1.02) translateY(var(--hero-parallax-y,0px));filter:blur(var(--hero-blur,0px));}`;
  document.head.appendChild(style);
  window.addEventListener('scroll', () => {
    if(!ticking){ requestAnimationFrame(updateHeroScroll); ticking = true; }
  }, {passive:true});
  updateHeroScroll();
})();


// v2.4 Contact upload preview for form app/native file inputs
(function(){
  document.addEventListener('change', function(e){
    var input = e.target;
    if (!input || input.type !== 'file' || !input.files || !input.files[0]) return;
    var wrapper = input.closest('.contact-form-wrapper');
    if (!wrapper) return;
    var old = input.parentNode.querySelector('.contact-upload-preview');
    if (old) old.remove();
    if (!input.files[0].type || input.files[0].type.indexOf('image/') !== 0) return;
    var img = document.createElement('img');
    img.className = 'contact-upload-preview';
    img.alt = 'Uploaded reference preview';
    img.src = URL.createObjectURL(input.files[0]);
    input.insertAdjacentElement('afterend', img);
  });
})();

// v3.0 mobile navigation/search toggles — guarded and desktop-safe
(function(){
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const searchToggle = document.querySelector('[data-mobile-search-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav-panel]');
  const globalSearch = document.querySelector('[data-global-color-search]');

  function closeMobileMenu(){
    document.body.classList.remove('mobile-menu-open');
    if(menuToggle) menuToggle.setAttribute('aria-expanded','false');
    if(mobileNav) mobileNav.setAttribute('aria-hidden','true');
  }
  function closeMobileSearch(){
    document.body.classList.remove('mobile-search-open');
  }

  if(menuToggle){
    menuToggle.addEventListener('click', function(){
      const isOpen = document.body.classList.toggle('mobile-menu-open');
      if(isOpen) closeMobileSearch();
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if(mobileNav) mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  if(searchToggle){
    searchToggle.addEventListener('click', function(){
      const isOpen = document.body.classList.toggle('mobile-search-open');
      if(isOpen){
        closeMobileMenu();
        setTimeout(function(){ if(globalSearch) globalSearch.focus(); }, 60);
      }
    });
  }

  // Close the mobile menu immediately when a menu link is tapped.
  // This prevents the drawer from persisting during same-window navigation or preview-router transitions.
  if(mobileNav){
    mobileNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        closeMobileMenu();
        closeMobileSearch();
      });
    });
  }

  // Also reset mobile UI if the browser restores/loads a page from cache.
  window.addEventListener('pageshow', function(){
    closeMobileMenu();
    closeMobileSearch();
  });

  document.addEventListener('click', function(e){
    if(document.body.classList.contains('mobile-menu-open') && !e.target.closest('.mobile-nav-panel') && !e.target.closest('[data-mobile-menu-toggle]')) closeMobileMenu();
    if(document.body.classList.contains('mobile-search-open') && !e.target.closest('.header-search') && !e.target.closest('[data-mobile-search-toggle]')) closeMobileSearch();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      closeMobileMenu();
      closeMobileSearch();
    }
  });

  window.addEventListener('resize', function(){
    if(window.innerWidth > 900){
      closeMobileMenu();
      closeMobileSearch();
    }
  }, {passive:true});
})();

/* mobileNavAutoClosePatch */
document.addEventListener('click', function(e) {
  var link = e.target.closest && e.target.closest('a');
  if (!link) return;
  var mobileMenu = document.querySelector('.mobile-menu, .mobile-nav, [data-mobile-menu], .nav-drawer');
  var menuToggle = document.querySelector('.mobile-menu-toggle, .hamburger, [data-mobile-menu-toggle]');
  document.body.classList.remove('mobile-menu-open','nav-open','menu-open');
  if (mobileMenu) {
    mobileMenu.classList.remove('open','active','is-open');
    mobileMenu.setAttribute('aria-hidden','true');
  }
  if (menuToggle) menuToggle.setAttribute('aria-expanded','false');
});
window.addEventListener('pageshow', function() {
  document.body.classList.remove('mobile-menu-open','nav-open','menu-open');
});


/* v3.0.31 reset color-card lighting on mouse leave */
document.addEventListener('mouseleave', function(event) {
  var card = event.target && event.target.closest ? event.target.closest('.color-card, .paint-card') : null;
  if (!card) return;
  card.style.removeProperty('--mouse-x');
  card.style.removeProperty('--mouse-y');
  card.classList.remove('is-lit', 'has-light', 'mouse-active');
}, true);



/* === v3.0.170 single-owner Colors filtering/grouping lifecycle ===
   This module is the only runtime owner for Colors filtering, grouping, active chips,
   mobile drawer state, search, and marque quick filters. Guarding prevents duplicate
   initialization/listeners on mobile browser restore or Shopify section reloads. */
(function(){
  var section = document.querySelector('.color-builder-section');
  if(!section) return;
  var form = section.querySelector('[data-specd-horizon-facets]');
  var grid = section.querySelector('[data-color-grid]');
  if(!form || !grid) return;
  if(form.dataset.specdFiltersInitialized === 'true') return;
  form.dataset.specdFiltersInitialized = 'true';
  window.__SpecdColorFiltersInitialized = true;

  var nativeFacets = String(form.getAttribute('data-shopify-native-facets')).toLowerCase() === 'true';
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-filter-card], .color-card')).filter(function(card){
    return !card.matches('[data-filter-group-heading], .group-heading');
  });
  var panel = form.querySelector('[data-facets-panel]');
  var search = form.querySelector('[data-color-search]');
  var searchClear = form.querySelector('[data-filter-search-clear]');
  var sort = form.querySelector('[data-sort-select]');
  var group = form.querySelector('[data-group-select]');
  var clear = form.querySelector('[data-clear-filters]');
  var chipsWrap = section.querySelector('[data-active-filter-chips-wrap]');
  var chipsList = section.querySelector('[data-active-filter-chips]');
  var chipsClear = section.querySelector('[data-active-filter-chips-clear]');
  var viewResultsBtn = form.querySelector('[data-facets-view-results]');
  var openBtn = form.querySelector('[data-facets-open]');
  var countEl = form.querySelector('[data-active-filter-count]');
  var closeBtns = form.querySelectorAll('[data-facets-close]');
  var scrim = form.querySelector('[data-facets-close].specd-horizon-facets__scrim, [data-facets-close].facets__scrim');
  var formId = form.getAttribute('id') || 'SpecdColorFiltersForm';
  form.setAttribute('id', formId);

  function isMobileFacets(){
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function assignFormOwner(root){
    if(!root) return;
    Array.prototype.slice.call(root.querySelectorAll('input, select, button')).forEach(function(el){
      if(el.type === 'button' || el.hasAttribute('data-facets-close') || el.hasAttribute('data-facets-open') || el.hasAttribute('data-filter-search-clear')) return;
      el.setAttribute('form', formId);
    });
  }

  function hostMobileDrawer(){
    if(!isMobileFacets()) return;
    assignFormOwner(panel);
    if(panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    if(scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
  }

  function clean(v){ return String(v == null ? '' : v).replace(/\s+/g,' ').trim(); }
  function key(v){ return clean(v).toLowerCase(); }
  function esc(v){ return clean(v).replace(/[&<>\"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[c]; }); }
  function cardInfo(card){
    var d = card.dataset || {};
    var h = card.querySelector('h4,h3,[data-color-name]');
    return {
      el: card,
      name: clean(d.name || (h ? h.textContent : '')),
      code: clean(d.code || d.paintCode || d.colorCode),
      brand: clean(d.brand),
      family: clean(d.family || d.group || d.colorFamily),
      finish: clean(d.finish),
      availability: clean(d.availability),
      search: key([d.name || (h ? h.textContent : ''), d.code || '', d.brand || '', d.group || d.family || '', d.finish || '', d.availability || ''].join(' '))
    };
  }
  var data = cards.map(cardInfo);

  function optionHtml(facet, value, count){
    var id = 'facet-' + facet + '-' + key(value).replace(/[^a-z0-9]+/g,'-');
    return '<label class="specd-facet__option" for="'+esc(id)+'" data-filter-option-label><input id="'+esc(id)+'" type="checkbox" data-filter-checkbox data-filter-facet="'+esc(facet)+'" data-filter-value="'+esc(value)+'" value="'+esc(value)+'"><span>'+esc(value)+'</span><small data-filter-option-count>'+count+'</small></label>';
  }
  function buildPreviewFallbackOptions(){
    if(nativeFacets) return;
    ['brand','family','finish','availability'].forEach(function(facet){
      var wrap = form.querySelector('[data-fallback-options="'+facet+'"]');
      if(!wrap) return;
      var counts = {};
      data.forEach(function(item){ var v = clean(item[facet]); if(v) counts[v]=(counts[v]||0)+1; });
      wrap.innerHTML = Object.keys(counts).sort(function(a,b){ return a.localeCompare(b, undefined, {sensitivity:'base'}); }).map(function(v){ return optionHtml(facet, v, counts[v]); }).join('');
    });
  }
  buildPreviewFallbackOptions();

  function setDrawer(open){
    if(open) hostMobileDrawer();
    form.classList.toggle('is-facets-open', !!open);
    if(panel) panel.classList.toggle('is-facets-open', !!open);
    if(scrim) scrim.classList.toggle('is-facets-open', !!open);
    document.body.classList.toggle('specd-mobile-filters-open', !!open);
    if(openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  function getActiveCheckboxCount(){ return facetInputs().filter(function(input){ return input.checked; }).length; }
  function getNativeActiveCount(){
    var active = getActiveCheckboxCount();
    if(search && search.value.trim()) active++;
    return active;
  }
  function updateActiveState(count){
    var c = typeof count === 'number' ? count : getNativeActiveCount();
    if(countEl){ countEl.textContent = String(c); countEl.hidden = c === 0; }
    if(openBtn) openBtn.setAttribute('aria-label', c ? ('Open filters, ' + c + ' active') : 'Open filters');
    if(clear) clear.hidden = c === 0;
    updateFilterSearchClear();
    renderActiveFilterChips();
  }
  function updateFilterSearchClear(){ if(searchClear && search) searchClear.hidden = !search.value.trim(); }

  function facetInputs(){
    // The mobile drawer is moved out to <body> so it can behave like a true full-screen overlay.
    // Once that happens, form.querySelectorAll() no longer sees the facet controls.
    // Always read/write controls from both locations.
    var nodes = [];
    [form, panel].forEach(function(root){
      if(!root) return;
      Array.prototype.slice.call(root.querySelectorAll('[data-filter-checkbox]')).forEach(function(input){
        if(nodes.indexOf(input) === -1) nodes.push(input);
      });
    });
    return nodes;
  }

  function submitNative(){
    // Keep collection filters in-page so Shopify native facets do not cause a full-page flash.
    renderPreview();
    return false;
  }

  function normalizeFacetName(label){
    var v = key(label);
    if(v.indexOf('brand') !== -1 || v.indexOf('marque') !== -1 || v.indexOf('make') !== -1) return 'brand';
    if(v.indexOf('family') !== -1 || v.indexOf('group') !== -1 || v.indexOf('color') !== -1 || v.indexOf('colour') !== -1) return 'family';
    if(v.indexOf('finish') !== -1 || v.indexOf('metallic') !== -1) return 'finish';
    if(v.indexOf('availability') !== -1 || v.indexOf('available') !== -1 || v.indexOf('pts') !== -1) return 'availability';
    return '';
  }

  function getSelectedFacetEntries(){
    var entries = [];
    var seen = {};
    facetInputs().filter(function(input){ return input.checked; }).forEach(function(input){
      var facet = input.getAttribute('data-filter-facet') || normalizeFacetName(input.getAttribute('data-filter-label') || input.name || '');
      if(!facet){
        var details = input.closest && input.closest('[data-facet-disclosure], details');
        var summary = details ? details.querySelector('summary span, .facet__summary span') : null;
        facet = normalizeFacetName(summary ? summary.textContent : '');
      }
      var value = input.getAttribute('data-filter-value') || (input.closest('label') && input.closest('label').querySelector('span') ? input.closest('label').querySelector('span').textContent : input.value);
      var valueKey = key(value);
      if(!facet || !valueKey) return;
      var id = facet + '::' + valueKey;
      if(seen[id]) return;
      seen[id] = true;
      entries.push({ facet: facet, value: clean(value), key: valueKey });
    });
    return entries;
  }

  function selectedPreviewFacets(){
    var state = {brand:[], family:[], finish:[], availability:[]};
    getSelectedFacetEntries().forEach(function(entry){
      if(state[entry.facet]) state[entry.facet].push(entry.key);
    });
    return state;
  }

  function getInputFacet(input){
    var facet = input.getAttribute('data-filter-facet') || normalizeFacetName(input.getAttribute('data-filter-label') || input.name || '');
    if(!facet){
      var details = input.closest && input.closest('[data-facet-disclosure], details');
      var summary = details ? details.querySelector('summary span, .facet__summary span') : null;
      facet = normalizeFacetName(summary ? summary.textContent : '');
    }
    return facet;
  }

  function getInputValue(input){
    return input.getAttribute('data-filter-value') || (input.closest('label') && input.closest('label').querySelector('span') ? input.closest('label').querySelector('span').textContent : input.value);
  }

  function optionMatchesDynamicState(item, state, facetToIgnore){
    var q = key(search ? search.value : '');
    if(q && item.search.indexOf(q) === -1) return false;
    return ['brand','family','finish','availability'].every(function(facet){
      if(facet === facetToIgnore) return true;
      return !state[facet].length || state[facet].indexOf(key(item[facet])) !== -1;
    });
  }

  function updateDynamicFacetCounts(state){
    state = state || selectedPreviewFacets();
    facetInputs().forEach(function(input){
      var facet = getInputFacet(input);
      if(!facet || !state[facet]) return;
      var value = getInputValue(input);
      var valueKey = key(value);
      if(!valueKey) return;
      var count = data.filter(function(item){
        return key(item[facet]) === valueKey && optionMatchesDynamicState(item, state, facet);
      }).length;
      var label = input.closest && input.closest('label');
      var small = label ? (label.querySelector('[data-filter-option-count]') || label.querySelector('small')) : null;
      if(small) small.textContent = String(count);
      if(label) label.classList.toggle('is-disabled', count === 0 && !input.checked);
      // Keep zero-count values visible so users understand why no result exists.
      // The in-page renderer can safely allow selecting them and show an empty result set.
      input.disabled = false;
    });
  }

  function renderActiveFilterChips(){
    if(!chipsWrap || !chipsList) return;
    var entries = getSelectedFacetEntries();
    var hasSearch = !!(search && search.value.trim());
    var chips = entries.map(function(entry){
      return '<button type="button" class="specd-active-filter-chip" data-chip-remove data-chip-facet="'+esc(entry.facet)+'" data-chip-value="'+esc(entry.key)+'" aria-label="Remove '+esc(entry.value)+' filter"><span>'+esc(entry.value)+'</span><span aria-hidden="true">×</span></button>';
    });
    if(hasSearch){
      chips.push('<button type="button" class="specd-active-filter-chip" data-chip-clear-search aria-label="Clear search"><span>'+esc(search.value.trim())+'</span><span aria-hidden="true">×</span></button>');
    }
    chipsList.innerHTML = chips.join('');
    var hasActive = chips.length > 0;
    chipsWrap.hidden = !hasActive;
    if(chipsClear) chipsClear.hidden = !hasActive;
  }
  function previewMatch(item, state){
    var q = key(search ? search.value : '');
    if(q && item.search.indexOf(q) === -1) return false;
    return ['brand','family','finish','availability'].every(function(facet){
      return !state[facet].length || state[facet].indexOf(key(item[facet])) !== -1;
    });
  }
  function previewSort(items){
    var mode = sort ? sort.value : 'az';
    var dir = mode === 'za' || mode === 'title-descending' ? -1 : 1;
    return items.slice().sort(function(a,b){ return dir * a.name.localeCompare(b.name, undefined, {sensitivity:'base'}); });
  }
  function renderPreview(){
    var state = selectedPreviewFacets();
    updateDynamicFacetCounts(state);
    grid.classList.add('is-filtering');

    var matched = data.filter(function(item){ return previewMatch(item, state); });
    var matchedSet = [];
    matched.forEach(function(item){ matchedSet.push(item.el); });

    // Do not move matching cards to the bottom of the grid.
    // Hide non-matching cards in-place with a hard CSS class so the visibility failsafe
    // does not accidentally re-show them after filters are applied.
    data.forEach(function(item){
      var isMatch = matchedSet.indexOf(item.el) !== -1;
      item.el.hidden = !isMatch;
      item.el.classList.toggle('specd-filter-hidden', !isMatch);
      item.el.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      if(isMatch){
        item.el.style.removeProperty('display');
        item.el.style.removeProperty('visibility');
        item.el.style.opacity = '1';
      } else {
        item.el.style.display = 'none';
      }
    });

    // Apply sorting only to visible/matching cards so hidden cards do not appear above results.
    Array.prototype.slice.call(grid.querySelectorAll('[data-filter-group-heading], .group-heading')).forEach(function(h){ h.remove(); });
    var sortedMatched = previewSort(matched);
    var groupMode = group ? (group.value || 'brand') : 'brand';
    if(groupMode && groupMode !== 'none'){
      // Build true buckets first instead of relying on the currently sorted order.
      // This prevents repeated headings like Porsche / BMW / Porsche when cards are
      // alphabetized by color name rather than sorted by the selected group value.
      var buckets = {};
      sortedMatched.forEach(function(item){
        var rawLabel = clean(item[groupMode] || 'Other') || 'Other';
        var bucketKey = key(rawLabel) || 'other';
        if(!buckets[bucketKey]) buckets[bucketKey] = { label: rawLabel, items: [] };
        buckets[bucketKey].items.push(item);
      });
      Object.keys(buckets).sort(function(a,b){
        return buckets[a].label.localeCompare(buckets[b].label, undefined, {sensitivity:'base'});
      }).forEach(function(bucketKey){
        var bucket = buckets[bucketKey];
        var count = bucket.items.length;
        var heading = document.createElement('div');
        heading.className = 'group-heading color-group-heading';
        heading.setAttribute('data-filter-group-heading','true');
        heading.innerHTML = '<h3>'+esc(bucket.label)+'</h3><span>'+count+' color'+(count === 1 ? '' : 's')+'</span>';
        grid.appendChild(heading);
        bucket.items.forEach(function(item){ grid.appendChild(item.el); });
      });
    } else {
      sortedMatched.forEach(function(item){ grid.appendChild(item.el); });
    }

    updateActiveState();
    window.requestAnimationFrame(function(){ grid.classList.remove('is-filtering'); });
  }
  function resetPreview(e){
    if(e) e.preventDefault();
    facetInputs().forEach(function(i){ i.checked = false; });
    if(search) search.value = '';
    if(sort && sort.options.length) sort.selectedIndex = 0;
    if(group && group.options.length) group.value = 'brand';
    renderPreview();
  }

  function handleFacetChange(e){
    if(e) e.preventDefault();
    renderPreview();
  }
  form.addEventListener('change', handleFacetChange);
  if(group) group.addEventListener('change', handleFacetChange);
  if(panel) panel.addEventListener('change', handleFacetChange);
  form.addEventListener('submit', function(e){ e.preventDefault(); renderPreview(); });
  function getFixedOffset(){
    var offset = 16;
    var selectors = ['.site-header', '.header-wrapper', '.shopify-section-header', 'header[role="banner"]', '.specd-header'];
    selectors.forEach(function(sel){
      var el = document.querySelector(sel);
      if(!el) return;
      var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
      var rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if(rect && rect.height && (!style || style.position === 'fixed' || style.position === 'sticky')){
        offset = Math.max(offset, rect.height + 18);
      }
    });
    return offset;
  }

  function scrollToColorResultsStart(){
    if(!grid) return;
    var target = section.querySelector('.specd-horizon-facets, [data-specd-horizon-facets]') || grid;
    var y = target.getBoundingClientRect().top + window.pageYOffset - getFixedOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function setBrandFilter(brand, shouldScroll){
    var brandKey = key(brand);
    if(!brandKey) return;
    facetInputs().forEach(function(input){
      if((input.getAttribute('data-filter-facet') || '').toLowerCase() === 'brand'){
        input.checked = key(input.getAttribute('data-filter-value') || input.value) === brandKey;
      }
    });
    if(group) group.value = 'brand';
    if(search) search.value = '';
    renderPreview();
    document.querySelectorAll('[data-brand-quick-filter]').forEach(function(btn){
      btn.classList.toggle('is-active', key(btn.getAttribute('data-brand-quick-filter')) === brandKey);
    });
    if(shouldScroll){
      window.setTimeout(scrollToColorResultsStart, 40);
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[data-brand-quick-filter]') : null;
    if(!btn) return;
    e.preventDefault();
    setBrandFilter(btn.getAttribute('data-brand-quick-filter'), true);
    setDrawer(false);
  });

  (function applyInitialBrandFromUrl(){
    try{
      var params = new URLSearchParams(window.location.search);
      var brand = params.get('brand') || params.get('marque');
      if(brand) setBrandFilter(brand, false);
    }catch(_){ }
  })();

  if(search){
    var lastSearchWasEmpty = !search.value.trim();
    search.addEventListener('input', function(){
      var nowHasSearch = !!search.value.trim();
      if(lastSearchWasEmpty && nowHasSearch){
        scrollToColorResultsStart();
      }
      lastSearchWasEmpty = !nowHasSearch;
      renderPreview();
      updateFilterSearchClear();
    });
  }
  if(searchClear){
    searchClear.addEventListener('click', function(e){
      e.preventDefault();
      if(search) search.value = '';
      renderPreview();
      updateFilterSearchClear();
      if(search) search.focus();
    });
  }
  if(clear) clear.addEventListener('click', resetPreview);
  if(chipsClear) chipsClear.addEventListener('click', resetPreview);
  if(chipsList) chipsList.addEventListener('click', function(e){
    var searchChip = e.target && e.target.closest ? e.target.closest('[data-chip-clear-search]') : null;
    if(searchChip){
      e.preventDefault();
      if(search) search.value = '';
      renderPreview();
      updateFilterSearchClear();
      return;
    }
    var chip = e.target && e.target.closest ? e.target.closest('[data-chip-remove]') : null;
    if(!chip) return;
    e.preventDefault();
    var facet = chip.getAttribute('data-chip-facet');
    var valueKey = chip.getAttribute('data-chip-value');
    facetInputs().forEach(function(input){
      var inputFacet = getInputFacet(input);
      var inputValue = getInputValue(input);
      if(inputFacet === facet && key(inputValue) === valueKey) input.checked = false;
    });
    renderPreview();
  });
  if(viewResultsBtn) viewResultsBtn.addEventListener('click', function(e){ e.preventDefault(); setDrawer(false); });
  if(openBtn) openBtn.addEventListener('click', function(){ setDrawer(!form.classList.contains('is-facets-open')); });
  Array.prototype.slice.call(closeBtns).forEach(function(btn){ btn.addEventListener('click', function(){ setDrawer(false); }); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setDrawer(false); });
  updateActiveState();
  renderPreview();
  window.SpecdColorFilters = { render: renderPreview, reset: resetPreview, isNative: nativeFacets, initialized: true };
})();

/* === v3.0.73 keep approved mobile kit collapse + How It Works mobile nav safeguard === */
(function(){
  var kitTray = document.querySelector('.kit-tray.builder-tray');
  if(kitTray){
    var kitToggle = kitTray.querySelector('.mobile-kit-toggle');
    if(!kitToggle){
      kitToggle = document.createElement('button');
      kitToggle.type = 'button';
      kitToggle.className = 'mobile-kit-toggle';
      kitTray.appendChild(kitToggle);
    }
    function syncKitToggle(){
      var expanded = kitTray.classList.contains('is-expanded');
      kitToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      kitToggle.setAttribute('aria-label', expanded ? 'Hide kit' : 'View kit');
      kitToggle.innerHTML = expanded ? '⌄' : '⌃';
    }
    kitTray.classList.remove('is-collapsed');
    kitTray.classList.remove('is-expanded');
    syncKitToggle();
    kitToggle.addEventListener('click', function(){
      kitTray.classList.toggle('is-expanded');
      kitTray.classList.remove('is-collapsed');
      syncKitToggle();
    });
  }
  document.querySelectorAll('.mobile-nav-inner a').forEach(function(link){
    var label = (link.textContent || '').trim().toLowerCase();
    var href = link.getAttribute('href') || '';
    if(label.indexOf('how it works') !== -1 && (href === '/' || href === '#how-it-works' || href === '#how')) link.setAttribute('href','/pages/how-it-works');
  });
})();



/* === v3.0.74 mobile kit button label safeguard === */
(function(){
  var addBtn = document.querySelector('[data-add-kit]');
  if(addBtn) addBtn.textContent = 'Add to Cart';
})();


/* === v3.0.75 mobile How It Works route safeguard === */
(function(){
  function normalizeHowItWorksLinks(){
    var isPreview = !!document.querySelector('.preview-page[data-page="how-it-works"]');
    document.querySelectorAll('.mobile-nav-inner a, .nav a').forEach(function(link){
      var label = (link.textContent || '').trim().toLowerCase();
      if(label.indexOf('how it works') === -1) return;
      link.setAttribute('href', isPreview ? '#how-it-works' : '/pages/how-it-works');
      if(isPreview) link.setAttribute('data-preview-link','');
    });
  }
  document.addEventListener('DOMContentLoaded', normalizeHowItWorksLinks);
  window.addEventListener('pageshow', normalizeHowItWorksLinks);
})();


/* === v3.0.76 mobile overlay and How It Works routing safeguards === */
(function(){
  function closeMobileFacets(){
    document.body.classList.remove('specd-mobile-filters-open');
    document.querySelectorAll('[data-specd-horizon-facets], .specd-horizon-facets').forEach(function(form){
      form.classList.remove('is-facets-open');
      var btn = form.querySelector('[data-facets-open]');
      if(btn) btn.setAttribute('aria-expanded','false');
    });
  }
  document.addEventListener('click', function(e){
    if(e.target.closest && (e.target.closest('[data-mobile-search-toggle]') || e.target.closest('[data-mobile-menu-toggle]'))){
      closeMobileFacets();
    }
  }, true);
  function normalizeHowItWorksLinks(){
    var isPreview = !!document.querySelector('.preview-page[data-page="how-it-works"]');
    document.querySelectorAll('.mobile-nav-inner a, .nav a, .footer-links a').forEach(function(link){
      var label = (link.textContent || '').trim().toLowerCase();
      if(label.indexOf('how it works') === -1) return;
      if(isPreview){
        link.setAttribute('href','#how-it-works');
        link.setAttribute('data-preview-link','');
      }else{
        link.setAttribute('href','/pages/how-it-works');
        link.removeAttribute('data-preview-link');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', normalizeHowItWorksLinks);
  window.addEventListener('pageshow', normalizeHowItWorksLinks);
})();

/* === v3.0.149 normal navigation: page fade/link interception removed === */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    document.body.classList.add('specd-page-ready');
    document.body.classList.remove('specd-page-fading','specd-page-leaving','is-transitioning','transitioning','page-loading','specd-loading');
  });
  window.addEventListener('pageshow', function(){
    document.body.classList.add('specd-page-ready');
    document.body.classList.remove('specd-page-fading','specd-page-leaving','is-transitioning','transitioning','page-loading','specd-loading');
  });
})();

/* === v3.0.106 mobile collapsed kit cart shortcut === */
(function(){
  var kitTray = document.querySelector('.kit-tray.builder-tray');
  if(!kitTray) return;
  var addBtn = kitTray.querySelector('[data-add-kit]');
  var toggleBtn = kitTray.querySelector('.mobile-kit-toggle');
  if(!addBtn || !toggleBtn) return;

  var mobileCartBtn = kitTray.querySelector('[data-mobile-collapsed-add-kit]');
  if(!mobileCartBtn){
    mobileCartBtn = document.createElement('button');
    mobileCartBtn.type = 'button';
    mobileCartBtn.className = 'mobile-collapsed-cart-button';
    mobileCartBtn.setAttribute('data-mobile-collapsed-add-kit', '');
    mobileCartBtn.setAttribute('aria-label', 'Add kit to cart');
    mobileCartBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 18.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM4.3 4l1.9 9.7c.2 1 1.1 1.8 2.1 1.8h8.8c1 0 1.9-.7 2.1-1.7l1-5.1H7.1L6.5 5.5H3V4h1.3Zm3.1 6.2h10.9l-.6 3.2c-.1.4-.4.6-.8.6H8.4c-.4 0-.7-.3-.8-.6l-.2-3.2Z"/></svg>';
    toggleBtn.insertAdjacentElement('afterend', mobileCartBtn);
  }

  function syncMobileCartBtn(){
    mobileCartBtn.disabled = !!addBtn.disabled;
    mobileCartBtn.setAttribute('aria-disabled', addBtn.disabled ? 'true' : 'false');
  }

  mobileCartBtn.addEventListener('click', function(event){
    event.preventDefault();
    event.stopPropagation();
    if(addBtn.disabled) return;
    addBtn.click();
  });

  syncMobileCartBtn();
  new MutationObserver(syncMobileCartBtn).observe(addBtn, { attributes:true, attributeFilter:['disabled'] });
})();


/* === v3.0.107 close desktop filter dropdowns on outside click === */
(function(){
  document.addEventListener('click', function(e){
    var openDetails = document.querySelectorAll('.color-builder-section details[data-facet-disclosure][open]');
    if(!openDetails.length) return;
    var clickedInsideFacet = e.target.closest && e.target.closest('.color-builder-section details[data-facet-disclosure]');
    var clickedOpenButton = e.target.closest && e.target.closest('[data-facets-open], [data-facets-close]');
    if(clickedInsideFacet || clickedOpenButton) return;
    openDetails.forEach(function(details){ details.removeAttribute('open'); });
  });
})();


/* === v3.0.135 defensive color data guard for imported products === */
(function(){
  if(window.__specdSafeColorGrid135) return;
  window.__specdSafeColorGrid135 = true;
  function clean(v){
    if(v == null) return '';
    v = String(v).replace(/^\s*\[\s*/,'').replace(/\s*\]\s*$/,'').replace(/^['"]|['"]$/g,'');
    v = v.replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/\s+/g,' ').trim();
    return v;
  }
  function norm(card){
    if(!card || !card.dataset) return;
    ['name','code','paintCode','brand','group','family','colorFamily','finish','availability','description','hex','image','handle'].forEach(function(k){
      if(card.dataset[k] != null) card.dataset[k] = clean(card.dataset[k]);
    });
    card.style.visibility = '';
    card.style.opacity = card.hidden ? card.style.opacity : '';
  }
  function normalizeAll(){
    var grid = document.querySelector('[data-color-grid], .color-grid');
    if(!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-filter-card], .color-card'));
    cards.forEach(norm);
    if(!cards.length) return;
    // If no active search/filter and everything was hidden by a JS failure, show the products instead of blanking the page.
    var checked = document.querySelectorAll('[data-filter-checkbox]:checked, input[name^="filter."]:checked');
    var search = document.querySelector('[data-color-search]');
    var hasSearch = !!(search && search.value && search.value.trim());
    var visible = cards.filter(function(card){
      var cs = window.getComputedStyle(card);
      return !card.hidden && cs.display !== 'none' && cs.visibility !== 'hidden';
    });
    if(!visible.length && !checked.length && !hasSearch){
      cards.forEach(function(card){ card.hidden = false; card.style.display = ''; card.style.visibility = ''; card.style.opacity = ''; });
    }
  }
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(normalizeAll,0); setTimeout(normalizeAll,250); });
  document.addEventListener('shopify:section:load', function(){ setTimeout(normalizeAll,0); });
  document.addEventListener('change', function(e){ if(e.target && e.target.matches('input, select')) setTimeout(normalizeAll,0); }, true);
  document.addEventListener('input', function(e){ if(e.target && e.target.matches('input[type="search"], [data-color-search]')) setTimeout(normalizeAll,0); }, true);
  window.addEventListener('error', function(e){
    if(String(e.message || '').match(/JSON|Unexpected|color|filter|metafield|brand|finish|availability|image_url/i)) setTimeout(normalizeAll,50);
  });
  window.SpecdSafeColorGrid135 = { normalizeAll: normalizeAll, clean: clean };
})();
